"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optimisticUpsertStationNote = exports.updateCacheOnUpsertStationNote = exports.UPSERT_STATION_NOTE = exports.optimisticUpsertConceptNote = exports.updateCacheOnUpsertConceptNote = exports.UPSERT_CONCEPT_NOTE = exports.optimisticUpsertConceptChapter = exports.updateCacheOnUpsertConceptChapter = exports.UPSERT_CONCEPT_BOOK = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
/**
 * upsertConceptChapter
 */
exports.UPSERT_CONCEPT_BOOK = (0, client_1.gql) `
  mutation UpsertConceptChapter(
    $conceptId: Int!
    $explanation: String!
    $marksheetId: Int
  ) {
    restricted {
      upsertConceptChapter(
        conceptId: $conceptId
        explanation: $explanation
        marksheetId: $marksheetId
      ) {
        id
        conceptId
        userId
        explanation
        createdAt
        updatedAt
      }
    }
  }
`;
const updateCacheOnUpsertConceptChapter = (cache, result, options) => {
    const { upsertConceptChapter } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables) {
        return;
    }
    cache.writeFragment({
        id: cache.identify({
            id: variables.conceptId,
            __typename: 'Concept',
        }),
        data: {
            userChapter: upsertConceptChapter,
        },
        fragment: fragments_1.UPSERT_CONCEPT_CHAPTER_FRAGMENT,
    });
};
exports.updateCacheOnUpsertConceptChapter = updateCacheOnUpsertConceptChapter;
const optimisticUpsertConceptChapter = (data) => {
    const payload = {
        restricted: {
            upsertConceptChapter: {
                __typename: 'UserConceptChapter',
                ...data,
                id: Date.now(),
                conceptId: Date.now(),
                createdAt: new Date(),
                updatedAt: new Date(),
            },
        },
    };
    return payload;
};
exports.optimisticUpsertConceptChapter = optimisticUpsertConceptChapter;
/**
 * upsertConceptNote
 */
exports.UPSERT_CONCEPT_NOTE = (0, client_1.gql) `
  mutation UpsertConceptNote(
    $conceptId: Int!
    $note: String!
    $marksheetId: Int
  ) {
    restricted {
      upsertConceptNote(
        conceptId: $conceptId
        note: $note
        marksheetId: $marksheetId
      ) {
        id
        conceptId
        userId
        note
        createdAt
        updatedAt
      }
    }
  }
`;
const updateCacheOnUpsertConceptNote = (cache, result, options) => {
    const { upsertConceptNote } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !upsertConceptNote) {
        return;
    }
    cache.writeFragment({
        id: cache.identify({
            id: variables.conceptId,
            __typename: 'Concept',
        }),
        data: {
            userNote: upsertConceptNote,
        },
        fragment: fragments_1.UPSERT_CONCEPT_NOTE_FRAGMENT,
    });
};
exports.updateCacheOnUpsertConceptNote = updateCacheOnUpsertConceptNote;
const optimisticUpsertConceptNote = (data) => {
    const payload = {
        restricted: {
            upsertConceptNote: {
                __typename: 'UserConceptNote',
                ...data,
                id: Date.now(),
                conceptId: Date.now(),
                createdAt: new Date(),
                updatedAt: new Date(),
            },
        },
    };
    return payload;
};
exports.optimisticUpsertConceptNote = optimisticUpsertConceptNote;
/**
 * upsertStationNote
 */
exports.UPSERT_STATION_NOTE = (0, client_1.gql) `
  mutation UpsertStationNote($stationId: Int!, $note: String!) {
    restricted {
      upsertStationNote(stationId: $stationId, note: $note) {
        id
        stationId
        userId
        note
        createdAt
        updatedAt
      }
    }
  }
`;
const updateCacheOnUpsertStationNote = (cache, result, options) => {
    const { upsertStationNote } = result?.data?.restricted || {};
    const { variables } = options || {};
    if (!variables || !upsertStationNote) {
        return;
    }
    cache.writeFragment({
        id: cache.identify({
            id: variables.stationId,
            __typename: 'OsceStation',
        }),
        data: {
            userNote: upsertStationNote,
        },
        fragment: fragments_1.UPSERT_STATION_NOTE_FRAGMENT,
    });
};
exports.updateCacheOnUpsertStationNote = updateCacheOnUpsertStationNote;
const optimisticUpsertStationNote = (data) => {
    const payload = {
        restricted: {
            upsertStationNote: {
                __typename: 'UserStationNote',
                ...data,
                id: Date.now(),
                createdAt: new Date(),
                updatedAt: new Date(),
            },
        },
    };
    return payload;
};
exports.optimisticUpsertStationNote = optimisticUpsertStationNote;
